<template lang="html">
	<ag-table :columns="columnDefs" :rows="rowDataFiltered" :customOptions="tableOptions" @cellclick="handleCellClick"></ag-table>
</template>

<script>
import AgTable from '@/common/components/ag-table'
export default {
	name: 'Activity',
	props: ['elements', 'clickable'],
	components: {
		AgTable
	},
	data () {
		return {
			columnDefs: null,
			rowData: this.elements,
			tableOptions: {
        pagination: false,
        headerHeight: 30,
				rowHeight: 44,
			}
		}
	},
	beforeMount () {
		this.columnDefs = [
			{ name: 'Nom', field: 'name' },
			// { name: 'ID', field: 'id', cellType: 'light' },
			{ name: 'Admin', field: 'adminFullName', cellType: 'light' },
			{ name: 'Début du contrat', field: 'contract_start_date', cellType: 'shortDate' },
			{ name: 'Fin du contrat', field: 'contract_end_date', cellType: 'shortDate' },
			// { name: 'Dernière mise à jour', field: 'updated_at', cellType: 'shortDate' },
			{ name: 'Conseillers', field: 'numberOfAdvisors', cellType: 'number', width: 180 },
      { name: 'Clients', field: 'numberOfClients', cellType: 'number', width: 180 },
			{ name: 'Statut', field: 'enabled', cellType: 'statusAvailable', width: 80 }
		]
	},
	methods: {
		handleCellClick (e) {
			if (e.colDef.headerName === 'Statut') {
				this.$emit('statuschange', e)
			} else if (this.clickable && e.data && e.data.id) {
				this.$router.push({name: 'CabinetsDetails', params: {id: e.data.id}})
			}
		}
	},
	computed: {
		rowDataFiltered () {
      // console.log(this.elements)
			return this.elements.map((office) => {
        const filteredOffice = {...office};
        const format = 'DD/MM/YYYY h:mm';
        filteredOffice.contract_start_date = this.$moment(office.contract_start_date, format).toISOString();
        filteredOffice.contract_end_date = this.$moment(office.contract_end_date, format).toISOString();
        filteredOffice.numberOfClients = office.clients.length;
        filteredOffice.numberOfAdvisors = office.advisors.length;
        filteredOffice.adminFullName = office.admin.length === 0 ? null : `${office.admin[0].first_name} ${office.admin[0].last_name}`;
        return filteredOffice
      })
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// CabinetsTable.vue?1ab489fd